import { Filter, FilterGroupsVectorPtr } from "@imi-ernd-be/hyselect-engine";
import {
  buildValidationResult,
  ValidationResult,
} from "../../validationResults/buildValidationResult";
import { toArray } from "../../vector";
import {
  BooleanFieldDefinition,
  getBooleanDefinition,
} from "./getBooleanDefinition";
import {
  getNumberDefinition,
  NumberFieldDefinition,
} from "./getNumberDefinition";
import {
  getOptionsFieldDefinition,
  OptionsFieldDefinition,
} from "./getOptionsFieldDefinition";

export type FilterFieldDefinition = {
  id: string;
  name: string;
} & (BooleanFieldDefinition | NumberFieldDefinition | OptionsFieldDefinition);

export type FilterGroupsFieldDefinition = {
  filters: FilterFieldDefinition[];
  id: string;
  type: "filterGroups";
  validationResult: ValidationResult | null;
};

export function getFilterGroupsDefinition(
  filterGroups: FilterGroupsVectorPtr,
): FilterGroupsFieldDefinition[] {
  return toArray(filterGroups).map((filterGroup) => {
    const validationResult = buildValidationResult(
      filterGroup.getValidationResult(),
    );
    return {
      filters: toArray(filterGroup.filters).map((filter) =>
        buildFilter(filter),
      ),
      id: filterGroup.id.replaceAll(".", "_"),
      type: "filterGroups",
      validationResult,
    };
  });
}

const FilterType = {
  BooleanField: 2,
  NumberField: 1,
  OptionField: 0,
};

function buildFilter(filter: Filter) {
  if (filter.type.value === FilterType.BooleanField) {
    return {
      name: filter.name,
      ...getBooleanDefinition(filter.booleanField()),
    };
  }

  if (filter.type.value === FilterType.NumberField) {
    return {
      id: filter.name.replaceAll(".", "_"),
      name: filter.name,
      ...getNumberDefinition(filter.numberField()),
    };
  }

  return {
    name: filter.name,
    ...getOptionsFieldDefinition(filter.optionField()),
  };
}
